import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'semantic-ui-css/semantic.min.css'
import { Auth0Provider } from '@auth0/auth0-react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './Home';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <Auth0Provider
        domain="ceres-imo-stub.us.auth0.com"
        clientId="0ipmZFfSSUm8vicIfdRTCSwAESPFj14v"
        authorizationParams={{
            redirect_uri: window.location.origin,
            audience: "https://imo-integration.api.qa1.ceresinsurance.com"
        }}
    >
        <Router>
            <Routes>
                <Route path="/" element={<App />} />                
            </Routes>
        </Router>
    </Auth0Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
